module.exports = __webpack_public_path__ + "img/firstview-0a2399dc555cbfd59e5e87bc1dde3242.fd3d7904.jpg";